<script context="module">
	//live
	export const url = 'https://uxolosupport.ch'
	export const downloadUrl = 'https://uxolosupport.ch/'
	// export const recaptcha = '6LeSDfUZAAAAAFnV9m4Uk1RJZubRmWwUtz8QPJhD'

	/*
	NOTE THAT ACCESS CONTROL IN TWILIO MUST BE UPDATED FOR DEV AND LIVE!!
	*/

	//dev
	// export const url = 'https://kybo-builder.test'
	// export const downloadUrl = 'https://kybo-builder.test/'
	// export const recaptcha = '6LdMzeIZAAAAAA-C0HIZwXVz0XCQ1Ty_XjebdOIp'

	//no changes here!!!
	export const urlShop = url + '/PHP/shopHandler.php'
	export const urlAdmin = url + '/PHP/adminHandler.php'
	export const urlExamples = url + '/PHP/examplesHandler.php'
	export const urlTranslate = url + '/PHP/translate.php'

	// language depending
	export const cookieConsent = 'We use cookies and other technologies to ensure that this website functions properly.'
	export const cookieConsent1 = "By clicking 'ok', you agree to their use."
</script>
